import { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  InputBase,
  Typography,
  MenuItem,
  Button,
  useTheme,
  useMediaQuery,
  Avatar,
  Divider,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ClickAwayListener,
  Drawer,
  AppBar,
  Toolbar,
} from "@mui/material";
import {
  Search,
  ChatBubbleOutline,
  NotificationsNone,
  CloudUploadOutlined,
  AccountCircleOutlined,
  SettingsOutlined,
  VideoLibraryOutlined,
  ExitToAppOutlined,
  MenuOpenOutlined,
  Brightness4Outlined,
  Brightness7Outlined,
  SwapHorizOutlined,
  Close,
  Menu,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setMode, setLogout } from "state";
import { useNavigate, useParams } from "react-router-dom";
import FlexBetween from "components/FlexBetween";
import UserImage from "components/UserImage";
import logo from './img/logo.png';
import { toast } from "react-toastify";
import { Check } from "@mui/icons-material";
// Add these imports at the top of your file
import { Client, Storage, ID, Query, Databases } from "appwrite";
// In Navbar.jsx, update the imports
import { 
  acceptFollowRequest, 
  rejectFollowRequest, 
  getPendingFollowRequests,
  createFollowAcceptedNotificationSafe,
  createPostUploadNotificationForFollowersSafe // Add this
} from './appwriteFollowService';

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.token);
  // To this
const [localUser, setLocalUser] = useState(null);
  
  const user = useSelector((state) => state.user);
  const _id = user?._id;


// Inside the Navbar component, add these functions to get the profile image URL
const [profileImageURL, setProfileImageURL] = useState(null);

const client = new Client();
client
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT)
  .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID);

const databases = new Databases(client);
const storage = new Storage(client);

// Constants
const DATABASE_ID = "681f7caf0033c79e0bc0";
const NOTIFICATION_ID = "681f845c0032fe308afb";

  // Media queries for responsive design
  const isExtraSmallScreen = useMediaQuery("(max-width:599px)");
  const isSmallScreen = useMediaQuery("(max-width:899px)");
  const isMediumScreen = useMediaQuery("(max-width:1199px)");
  const isLargeScreen = useMediaQuery("(min-width:1200px)");

  const theme = useTheme();
  const darkMode = theme.palette.mode === "dark";
  const neutralLight = theme.palette.neutral.light;
  const primaryLight = theme.palette.primary.light;
  const alt = theme.palette.background.alt;

  const fullName = user ? `${user.firstName} ${user.lastName}` : "";
  const profilePicture = user?.picturePath || "/default-avatar.png";
  const [searchTimeout, setSearchTimeout] = useState(null);

  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [followRequests, setFollowRequests] = useState([]);
  const currentUserId = user?._id;

  // Initialize Appwrite client
  // COMMENTED OUT: Appwrite initialization for profile picture upload
  /*
  const appwriteClient = new Client();
  
  // Set your Appwrite endpoint and project ID
  appwriteClient
    .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT || "https://cloud.appwrite.io/v1")
    .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID || "your-project-id");
  
  // Initialize Storage
  const storage = new Storage(appwriteClient);
  */
  
  // COMMENTED OUT: Profile picture upload state
  // const [isUploading, setIsUploading] = useState(false);
  
  // COMMENTED OUT: Profile picture upload handler
  /*
  const handleProfilePictureUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    try {
      setIsUploading(true);
      
      // Upload file to Appwrite storage
      const uploadResult = await storage.createFile(
        process.env.REACT_APP_APPWRITE_BUCKET_ID,
        ID.unique(),
        file
      );
      
      // Update user profile with new picture
      const response = await fetch(`http://localhost:3001/users/${user._id}/update-picture`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ picturePath: uploadResult.$id })
      });
      
      if (!response.ok) throw new Error("Failed to update profile picture");
      
      const updatedUser = await response.json();
      
      // Update local state if needed
      setLocalUser(updatedUser);
      
      // Update Redux state correctly
      dispatch({ 
        type: "SET_USER", 
        payload: { user: updatedUser } 
      });
      
      // If you're using a specific action creator from your Redux setup, use that instead
      // For example: dispatch(setUser({ user: updatedUser }));
      
      toast.success("Profile picture updated successfully!");
      
    } catch (error) {
      // console.error("Error uploading profile picture:", error);
      toast.error("Failed to update profile picture");
    } finally {
      setIsUploading(false);
    }
  };
  */


  // Function to get the image URL from Appwrite
const getProfileImageURL = async () => {
  if (user?.picturePath && user?.appwriteStorage) {
      try {
          const imageURL = storage.getFileView(
              process.env.REACT_APP_APPWRITE_BUCKET_ID,
              user.picturePath
          );
          setProfileImageURL(imageURL.href);
      } catch (error) {
          // console.error("Error getting profile image:", error);
          // Set default image if there's an error
          setProfileImageURL("/default-avatar.png");
      }
  } else {
      // Use traditional path or default image
      setProfileImageURL(user?.picturePath || "/default-avatar.png");
  }
};

// Add useEffect to load profile image when user changes
useEffect(() => {
  if (user) {
      getProfileImageURL();
  }
}, [user]);
  // Toggle Dropdown Menu
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  // Handle search input change
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    
    // Clear any pending search
    if (searchTimeout) clearTimeout(searchTimeout);
    
    // Only search if query has 2 or more characters
    if (query.length >= 2) {
      setIsSearching(true);
      
      // Debounce search to avoid too many API calls
      const timeoutId = setTimeout(() => {
        searchUsers(query);
      }, 300);
      
      setSearchTimeout(timeoutId);
    } else {
      setSearchResults([]);
      setShowResults(false);
      setIsSearching(false);
    }
  };

  // Function to search users
  const searchUsers = async (query) => {
    try {
      const response = await fetch(`https://my-pers-thing-server.onrender.com/users/search/${encodeURIComponent(query)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error("Search failed");
      
      const data = await response.json();
      setSearchResults(data);
      setShowResults(true);
      setIsSearching(false);
    } catch (error) {
      // console.error("Error searching users:", error);
      setIsSearching(false);
    }
  };

  // Handle user selection - redirects to the selected user's profile
  const handleUserSelect = (userId) => {
    navigate(`/profile/${userId}`);
    setSearchQuery("");
    setSearchResults([]);
    setShowResults(false);
  };

  // Close search results when clicking away
  const handleClickAway = () => {
    setShowResults(false);
  };

  // Fetch notifications
// In your Navbar.jsx, replace the fetchNotifications function:

// Replace the current fetchNotifications function with this updated version
const fetchNotifications = async () => {
  if (!user || !user._id) return;

  try {
    // Query Appwrite for notifications where receiverId matches current user ID
    const response = await databases.listDocuments(
      DATABASE_ID,
      NOTIFICATION_ID,
      [
        Query.equal('receiverId', user._id),
        Query.orderDesc('createdAt')
      ]
    );

    // Format notifications for UI
    const notificationsData = response.documents.map(doc => ({
      id: doc.$id,
      message: doc.type === 'like' 
        ? `${doc.senderName} liked your post`
        : doc.type === 'comment'
          ? `${doc.senderName} commented on your post: "${doc.content || ''}"`
          : `${doc.senderName} interacted with your content`,
      read: doc.isRead === true,
      createdAt: doc.createdAt,
      sender: {
        id: doc.senderId,
        firstName: doc.senderName.split(' ')[0],
        lastName: doc.senderName.split(' ')[1] || '',
        picturePath: doc.senderPicturePath
      },
      // Add these direct properties for easier access in the render function
      senderPicturePath: doc.senderPicturePath,
      senderName: doc.senderName,
      postId: doc.postId, // Make sure this is included
      type: doc.type // Include notification type for conditional rendering
    }));

    setNotifications(notificationsData || []);

    // Count unread notifications
    const unreadCount = notificationsData.filter(notif => !notif.read).length;
    setNotificationCount(unreadCount);
  } catch (error) {
    // console.error("Error fetching notifications:", error);
  }
};


// Mark notifications as read
// const markNotificationsAsRead = async () => {
//   if (!user || !user._id) return;
  
//   try {
//     await fetch(`http://localhost:3001/notifications/${user._id}/read`, {
//       method: "PATCH",
//       headers: { Authorization: `Bearer ${token}` }
//     });
    
//     // Update local state
//     setNotifications(prev => 
//       prev.map(notif => ({ ...notif, read: true }))
//     );
//     setNotificationCount(0);
//   } catch (error) {
    // console.error("Error marking notifications as read:", error);
//   }
// };
// const fetchNotifications = async () => {
//   if (!user || !user._id) return;
  
//   try {
//     // Query Appwrite for notifications where receiverId matches current user ID
//     const response = await databases.listDocuments(
//       DATABASE_ID,
//       NOTIFICATION_ID,
//       [
//         Query.equal('receiverId', user._id),
//         Query.orderDesc('createdAt')
//       ]
//     );
    
//     // Format notifications for UI
//     const notificationsData = response.documents.map(doc => ({
//       id: doc.$id,
//       message: doc.type === 'comment' 
//         ? `${doc.senderName} commented on your post: "${doc.content}"`
//         : `${doc.senderName} interacted with your content`,
//       read: doc.read,
//       createdAt: doc.createdAt,
//       sender: {
//         id: doc.senderId,
//         firstName: doc.senderName.split(' ')[0],
//         lastName: doc.senderName.split(' ')[1] || '',
//         picturePath: null // You might need to fetch this separately
//       }
//     }));
    
//     setNotifications(notificationsData || []);
    
//     // Count unread notifications
//     const unreadCount = notificationsData.filter(notif => !notif.read).length;
//     setNotificationCount(unreadCount);
//   } catch (error) {
//     console.error("Error fetching notifications:", error);
//   }
// };

// Update the markNotificationsAsRead function to handle the isRead field name correctly
const markNotificationsAsRead = async () => {
  if (!user || !user._id) return;

  try {
    // Get unread notifications
    const unreadNotifications = notifications.filter(notif => !notif.read);

    // Log for debugging
    // console.log("Unread notifications to mark as read:", unreadNotifications);

    // Update each notification to mark as read
    for (const notif of unreadNotifications) {
      // Make sure we're using the correct ID property
      const notificationId = notif.id; // This should be the Appwrite document ID

      // console.log(`Marking notification ${notificationId} as read`);

      try {
        await databases.updateDocument(
          DATABASE_ID,
          NOTIFICATION_ID,
          notificationId,
          { isRead: true }
        );

        // console.log(`Successfully marked notification ${notificationId} as read`);
      } catch (updateError) {
        // console.error(`Error updating notification ${notificationId}:`, updateError);
      }
    }

    // Update local state regardless of backend success
    setNotifications(prev => 
      prev.map(notif => ({ ...notif, read: true }))
    );
    setNotificationCount(0);
  } catch (error) {
    // console.error("Error marking notifications as read:", error);
  }
};


  // Handle accept/reject follow requests
  // Handle accept follow request
// Modified handleAcceptFollowRequest function
const handleAcceptFollowRequest = async (requesterId) => {
  try {
    // console.log(`Accepting request from ${requesterId}`);
    
    // Accept the follow request in Appwrite
    await acceptFollowRequest(user._id, requesterId);
    
    // Get user details for notification
    const currentUserResponse = await fetch(`https://my-pers-thing-server.onrender.com/users/${user._id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    const currentUserData = await currentUserResponse.json();
    const currentUserName = `${currentUserData.firstName} ${currentUserData.lastName}`;
    
    // Try to notify the requester that their request was accepted, but don't fail if it doesn't work
    try {
      // If you have a safe version use it, otherwise create one similar to the follow request safe version
      await createFollowAcceptedNotificationSafe(
        requesterId, // receiverId (the user who sent the request)
        user._id, // senderId (current user)
        currentUserName, // sender's name
        currentUserData.picturePath // sender's profile picture
      );
    } catch (notifError) {
      // Just log the error but don't break the flow
      // console.log("Notification creation failed but follow request was accepted:", notifError);
    }
    
    // Remove this request from followRequests array
    setFollowRequests(prev => prev.filter(request => request._id !== requesterId));
    
    // Show success toast
    toast.success("Follow request accepted");
    
    // Refresh notifications to update counts
    fetchNotifications();
    
    // Fetch follow requests again
    fetchFollowRequests();
  } catch (error) {
    // console.error("Error accepting follow request:", error);
    toast.error("Failed to accept follow request");
  }
};

 // Handle reject follow request
const handleRejectFollowRequest = async (requesterId) => {
  try {
    // console.log(`Rejecting request from ${requesterId}`);
    
    // Reject the follow request in Appwrite
    await rejectFollowRequest(user._id, requesterId);
    
    // Remove this request from followRequests array
    setFollowRequests(prev => prev.filter(request => request._id !== requesterId));
    
    // Show success toast
    toast.success("Follow request rejected");
    
    // Refresh notifications to update counts
    fetchNotifications();
    
    // Fetch follow requests again
    fetchFollowRequests();
  } catch (error) {
    // console.error("Error rejecting follow request:", error);
    toast.error("Failed to reject follow request");
  }
};
// In Navbar.jsx, update the renderNotificationMessage function:

const renderNotificationMessage = (notification) => {
  switch (notification.type) {
    case 'like':
      return `${notification.senderName} liked your post`;
    case 'comment':
      return `${notification.senderName} commented on your post: "${notification.content || ''}"`;
    case 'follow_request':
      return `${notification.senderName} wants to follow you`;
    case 'follow_accepted':
      return `${notification.senderName} accepted your follow request`;
    case 'post_upload':
      return `${notification.senderName} uploaded a new post`;
    default:
      return `${notification.senderName} interacted with your content`;
  }
};
  // Fetch follow requests
 // Fetch follow requests from Appwrite
const fetchFollowRequests = async () => {
  if (!user || !user._id) return;
  
  try {
    // Get pending follow requests from Appwrite
    const requests = await getPendingFollowRequests(user._id);
    
    // We need user details for each requester
    const requestsWithUserDetails = await Promise.all(requests.map(async (request) => {
      // Fetch user details from your backend
      const userResponse = await fetch(`https://my-pers-thing-server.onrender.com/users/${request.requesterId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (!userResponse.ok) throw new Error(`Failed to fetch user ${request.requesterId}`);
      
      const userData = await userResponse.json();
      
      // Combine request data with user data
      return {
        _id: request.requesterId, // Use the requesterId as _id
        $id: request.$id, // Appwrite document ID
        firstName: userData.firstName,
        lastName: userData.lastName,
        picturePath: userData.picturePath,
        username: userData.username,
        timestamp: request.timestamp
      };
    }));
    
    setFollowRequests(requestsWithUserDetails || []);
  } catch (error) {
    // console.error("Error fetching follow requests:", error);
  }
};
  // Update useEffect to also fetch follow requests
  useEffect(() => {
    if (!user || !user._id) return;
    
    fetchNotifications();
    fetchFollowRequests();
    
    // Set up polling for new notifications (every 30 seconds)
    const intervalId = setInterval(() => {
      fetchNotifications();
      fetchFollowRequests();
    }, 30000);
    
    return () => clearInterval(intervalId);
  }, [user, token]);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Close dropdowns when clicking on mobile menu items
  const handleMobileAction = (action) => {
    setMobileMenuOpen(false);
    action();
  };
  const handleNotificationClick = (notification) => {
    if (!notification.postId) return;
    
    // Close the notifications panel
    setShowNotifications(false);
    
    // Mark all notifications as read
    markNotificationsAsRead();
    
    // Navigate to the appropriate post based on notification type
    if (notification.type === 'comment') {
      navigate(`/home/post/${notification.postId}/comments`);
    } else {
      navigate(`/home/post/${notification.postId}`);
    }
  };
  // Add this useEffect hook to fetch notifications on component mount
useEffect(() => {
  if (user && user._id) {
    fetchNotifications();
    
    // Set up interval to periodically check for new notifications
    const notificationInterval = setInterval(() => {
      fetchNotifications();
    }, 30000); // Check every 30 seconds
    
    return () => {
      clearInterval(notificationInterval);
    };
  }
}, [user]);

  // Render search bar component
const renderSearchBar = () => (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box sx={{ 
        position: "relative", 
        width: isExtraSmallScreen ? "80%" : isSmallScreen ? "85%" : "40%",
        marginLeft: isExtraSmallScreen ? "10%" : "auto", // Center for mobile, push right for others
        marginRight: isExtraSmallScreen ? "5%" : isSmallScreen ? "5%" : "20%",  // Changed from 10% to 5% for extra small screens
        flexGrow: 0,
        maxWidth: isExtraSmallScreen ? "80%" : isSmallScreen ? "85%" : "40%",
      }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            border: "1.5px solid",
            borderColor: darkMode ? "#888" : "#888",
            borderRadius: "50px",
            padding: "0.6rem 1rem",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-1px)",
            },
          }}
        >
          <InputBase
            placeholder="Search users..."
            sx={{
              fontSize: "14.5px",
              width: "100%",
              color: darkMode ? "#e0e0e0" : "#111",
            }}
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <IconButton sx={{ padding: 0 }}>
            {isSearching ? (
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  animation: "spin 1s linear infinite",
                }}
              >
                <span
                  style={{
                    display: "block",
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    border: "2px solid #ccc",
                    borderTopColor: theme.palette.primary.main,
                  }}
                ></span>
              </Box>
            ) : (
              <Search sx={{ color: darkMode ? "#e0e0e0" : "#444" }} />
            )}
          </IconButton>
        </Box>

        {/* Search Results Dropdown */}
        {showResults && searchResults.length > 0 && (
          <Paper
            elevation={3}
            sx={{
              position: "absolute",
              width: isExtraSmallScreen ? "calc(100% + 120px)" : isSmallScreen ? "calc(100% + 100px)" : "100%", // Extremely wide on mobile
              maxHeight: "300px",
              overflowY: "auto",
              top: "48px",
              left: isExtraSmallScreen ? "-60px" : isSmallScreen ? "-50px" : "0", // Recentered for wider element
              zIndex: 10,
              borderRadius: "12px",
            }}
          >
            <List sx={{ padding: 0 }}>
              {searchResults.map((result) => (
                <ListItem
                  key={result._id}
                  onClick={() => handleUserSelect(result._id)}
                  sx={{
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                    borderBottom: "1px solid #eee",
                    padding: isExtraSmallScreen ? "10px 24px" : isSmallScreen ? "10px 20px" : "8px", // Add substantial horizontal padding on mobile
                  }}
                >
                  <ListItemAvatar>
                    <UserImage image={result.picturePath} size="40px" />
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${result.firstName} ${result.lastName}`}
                    secondary={`${result.username}`}
                    sx={{
                      // Ensure text doesn't get cut off
                      "& .MuiListItemText-primary": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      "& .MuiListItemText-secondary": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        )}

        {/* No Results */}
        {showResults &&
          searchQuery.length >= 2 &&
          searchResults.length === 0 &&
          !isSearching && (
            <Paper
              elevation={3}
              sx={{
                position: "absolute",
                width: isExtraSmallScreen ? "calc(100% + 120px)" : isSmallScreen ? "calc(100% + 100px)" : "100%", // Match the width of search results
                top: "48px",
                left: isExtraSmallScreen ? "-60px" : isSmallScreen ? "-50px" : "0", // Adjust position to match
                zIndex: 10,
                borderRadius: "10px",
                padding: "10px",
                textAlign: "center",
              }}
            >
              <Typography variant="body2" color="textSecondary">
                No users found
              </Typography>
            </Paper>
          )}
      </Box>
    </ClickAwayListener>
  );
  
  // Render notification button and dropdown
  const renderNotificationButton = () => (
    <IconButton 
      onClick={() => {
        setShowNotifications(!showNotifications);
        if (!showNotifications) markNotificationsAsRead();
      }}
      sx={{ position: "relative" }}
    >
      {showNotifications && (
        <Paper
          sx={{
            position: "absolute",
            top: "50px",
            right: isExtraSmallScreen ? "-100px" : "-150px",
            width: isExtraSmallScreen ? "280px" : "320px",
            maxHeight: "400px",
            overflowY: "auto",
            background: darkMode ? "rgba(255, 255, 255, 0.1)" : "#fff",
            borderRadius: "12px",
            zIndex: 10,
            p: "0.7rem",
            transition: "all 0.2s ease-in-out",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Notifications
            </Typography>
            <IconButton size="small" onClick={() => setShowNotifications(false)}>
              <Close fontSize="small" />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 1 }} />
          
          {/* Follow Requests Section */}
          {followRequests.length > 0 && (
            <>
              <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1, mb: 1 }}>
                Follow Requests ({followRequests.length})
              </Typography>
              
              {followRequests.map((request) => (
                <Box key={request._id} sx={{ 
                  py: 1.5, 
                  px: 1,
                  borderRadius: "8px",
                  mb: 1,
                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" }
                }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Avatar 
                      src={request.picturePath ? 
                        `https://my-pers-thing-server.onrender.com/assets/${request.picturePath}` : undefined}
                      alt={request.firstName || "User"}
                      sx={{ width: 40, height: 40 }}
                    />
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="body2">
                        <b>{request.firstName} {request.lastName}</b> wants to follow you
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <IconButton 
                        size="small" 
                        onClick={() => handleAcceptFollowRequest(request._id)}
                        sx={{ 
                          color: "white", 
                          bgcolor: "green", 
                          "&:hover": { bgcolor: "darkgreen" } 
                        }}
                      >
                        <Check fontSize="small" />
                      </IconButton>
                      <IconButton 
                        size="small" 
                        onClick={() => handleRejectFollowRequest(request._id)}
                        sx={{ 
                          color: "white", 
                          bgcolor: "red", 
                          "&:hover": { bgcolor: "darkred" } 
                        }}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
              ))}
              <Divider sx={{ my: 1 }} />
            </>
          )}
          
          {/* Regular Notifications */}
          {notifications.length === 0 && followRequests.length === 0 ? (
            <Typography sx={{ textAlign: "center", py: 2, color: "text.secondary" }}>
              No notifications yet
            </Typography>
          ) : (
            <>
              {notifications.length > 0 && (
                <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1, mb: 1 }}>
                  {/* Notifications */}
                </Typography>
              )}
              



{/* Notification display component in Navbar.jsx */}
{notifications.map((notification, index) => (
  <Box 
    key={index} 
    sx={{ 
      py: 1.5, 
      px: 1,
      borderRadius: "8px",
      mb: 1,
      backgroundColor: notification.read ? "transparent" : "rgba(25, 118, 210, 0.08)",
      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
      cursor: notification.postId ? "pointer" : "default", // Only make it clickable if there's a postId
      // cursor: "pointer", 
      transition: "all 0.2s ease"
    }}
    // onClick={() => {
    //   // Add navigation to the specific post when notification is clicked
    //   if (notification.postId) {
    //     // Close the notifications panel
    //     setShowNotifications(false);
    //     // Navigate to the post page
    //     navigate(`/home/post/${notification.postId}`);
    //     // If it's a comment notification, open the comments modal
    //     if (notification.type === 'comment') {
    //       // You may need to pass this information to the Post component
    //       // or handle it via URL parameters
    //       navigate(`/home/post/${notification.postId}/comments`);
    //     } else {
    //       navigate(`/home/post/${notification.postId}`);
    //     }
    //   }
    // }}

    onClick={() => {
      // Only navigate if there's a postId and it's not null
      if (notification.postId && notification.postId !== null) {
        setShowNotifications(false);
        
        if (notification.type === 'comment') {
          navigate(`/home/post/${notification.postId}/comments`);
        } else if (notification.type === 'post_upload') {
      navigate(`/home/post/${notification.postId}?source=shared`);
    }else {
          navigate(`/home/post/${notification.postId}`);
        }
      }
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      {/* Avatar rendering */}
      {notification.senderPicturePath ? (
        <UserImage 
          image={notification.senderPicturePath}
          size="40px"
        />
      ) : (
        <Avatar
          sx={{ width: 40, height: 40 }}
          alt={notification.senderName || "User"}
        >
          {notification.senderName ? notification.senderName.charAt(0).toUpperCase() : "U"}
        </Avatar>
      )}
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body2">
        {renderNotificationMessage(notification)}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {new Date(notification.createdAt).toLocaleString()}
        </Typography>
        {/* Add a "Click to view" text for postId notifications */}
        {notification.postId && notification.postId !== null && (
          <Typography 
            variant="caption" 
            sx={{ 
              display: "block", 
              color: "primary.main", 
              fontWeight: "bold", 
              mt: 0.5 
            }}
          >
            {notification.type === 'comment' ? 'Click to view comment →' : 'Click to view post →'}
          </Typography>
        )}
      </Box>
    </Box>
  </Box>
))}          </>
          )}
        </Paper>
      )}
      <NotificationsNone sx={{ fontSize: "26px" }} />
      {notificationCount > 0 && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            backgroundColor: "red",
            color: "white",
            borderRadius: "50%",
            width: "18px",
            height: "18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            fontWeight: "bold"
          }}
        >
          {notificationCount}
        </Box>
      )}
    </IconButton>
  );

  // Render upload button
  // Render upload button
  const renderUploadButton = () => (
    <Button
      startIcon={
        <CloudUploadOutlined
          sx={{
            fontSize: isExtraSmallScreen ? 16 : 22,
            transition: "transform 0.3s ease",
            ".MuiButton-root:hover &": {
              transform: "scale(1.1) rotate(-5deg)",
            },
          }}
        />
      }
      onClick={() => navigate(`/vid-upload/${_id}`)}
      sx={{
        borderRadius: "20px",
        textTransform: "none",
        padding: isExtraSmallScreen ? "6px 10px" : "10px 20px",
        fontWeight: 600,
        fontSize: isExtraSmallScreen ? "12px" : "15px",
        letterSpacing: "0.3px",
        minWidth: "auto",
        background: "linear-gradient(135deg, #FF61D2 0%, #FE9090 100%)",
        color: "#fff",
        transition: "all 0.3s ease",
        "&:hover": {
          background: "linear-gradient(135deg, #FE9090 0%, #FF61D2 100%)",
          transform: "scale(1.05)",
        },
        "&:active": {
          transform: "scale(0.97)",
        },
      }}
    >
      Upload
    </Button>
  )

  // Render user dropdown menu
  // Modify the UserDropdown component to remove profile picture upload functionality
  const renderUserDropdown = () => (
    isDropdownOpen && (
      <Paper
        sx={{
          position: "absolute",
          top: "75px",
          right: isExtraSmallScreen ? "10px" : "20px",
          width: "230px",
          background: darkMode ? "rgba(33, 33, 33, 0.95)" : "#fff",
          borderRadius: "12px",
          zIndex: 10,
          p: "0.7rem",
          transition: "all 0.3s ease",
          transform: isDropdownOpen ? "translateY(0px)" : "translateY(-10px)",
          opacity: isDropdownOpen ? 1 : 0,
          boxShadow: darkMode 
            ? "0 8px 32px rgba(0, 0, 0, 0.3)" 
            : "0 6px 20px rgba(0, 0, 0, 0.15)",
          overflow: "hidden",
          border: darkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "none",
        }}
      >
        {/* User info section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 2,
            pt: 1,
          }}
        >
          {/* COMMENTED OUT: Profile picture with upload functionality 
          <Box sx={{ position: "relative" }}>
            <label htmlFor="profile-picture-upload">
              <input
                id="profile-picture-upload"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleProfilePictureUpload}
              />
              <Box sx={{ 
                position: "relative", 
                cursor: "pointer",
                "&:hover::after": {
                  content: "'Change'",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(0,0,0,0.5)",
                  color: "#fff",
                  borderRadius: "50%",
                  fontWeight: "bold",
                  fontSize: "12px"
                }
              }}>
                <UserImage 
                  image={user?.picturePath} 
                  size="60px"
                  border={`2px solid ${theme.palette.primary.main}`}
                />
                {isUploading && (
                  <Box sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(0,0,0,0.5)",
                    borderRadius: "50%",
                  }}>
                    <Box
                      sx={{
                        width: 20,
                        height: 20,
                        animation: "spin 1s linear infinite",
                      }}
                    >
                      <span
                        style={{
                          display: "block",
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          border: "2px solid #ccc",
                          borderTopColor: theme.palette.primary.main,
                        }}
                      ></span>
                    </Box>
                  </Box>
                )}
              </Box>
            </label>
          </Box>
          */}
          
          {/* Replace with simple non-clickable profile image */}
          {/* <UserImage 
    image={profileImageURL} 
    size="60px"
    border={`2px solid ${theme.palette.primary.main}`}
/> */}
          
          <Typography
            variant="subtitle1"
            sx={{
              p: "0.5rem",
              textAlign: "center",
              fontWeight: "600",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "16px",
              color: darkMode ? "#fff" : "inherit",
            }}
          >
            {fullName}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              marginTop: "-8px",
              color: darkMode ? "rgba(255, 255, 255, 0.7)" : "text.secondary",
              fontSize: "13px",
            }}
          >
            {user?.email || ""}
          </Typography>
        </Box>
        
        {/* Rest of your existing dropdown menu */}
        <Divider sx={{ my: "0.8rem" }} />

        <MenuItem
          onClick={() => {
            dispatch(setLogout());
            navigate("/login");
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 15px",
            borderRadius: "8px",
            background: darkMode ? "rgba(244, 67, 54, 0.15)" : "rgba(244, 67, 54, 0.08)",
            transition: "all 0.25s ease",
            "&:hover": {
              backgroundColor: darkMode ? "rgba(244, 67, 54, 0.25)" : "rgba(244, 67, 54, 0.15)",
              transform: "translateY(-2px)",
            },
            "&:active": {
              transform: "translateY(1px)",
            },
          }}
        >
          <ExitToAppOutlined sx={{ 
            fontSize: "20px", 
            color: darkMode ? "#ff7961" : "#f44336",
          }} />
          <Typography sx={{ 
            fontSize: "14px", 
            fontWeight: "bold",
            color: darkMode ? "#ff7961" : "#f44336",
          }}>
            Logout
          </Typography>
        </MenuItem>
      </Paper>
    )
  );

  // Mobile drawer content
  const renderMobileDrawer = () => (
    <Drawer
      anchor="right"
      open={mobileMenuOpen}
      onClose={() => setMobileMenuOpen(false)}
    >
      <Box
        sx={{
          width: 250,
          height: "100%",
          bgcolor: darkMode ? "background.default" : "background.paper",
          p: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Menu
          </Typography>
          <IconButton onClick={() => setMobileMenuOpen(false)}>
            <Close />
          </IconButton>
        </Box>
        
        <Divider sx={{ mb: 2 }} />
        
        {/* User profile section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 3,
          }}
        >
          <UserImage 
            image={user?.picturePath} 
            size="80px"
            border={`2px solid ${theme.palette.primary.main}`}
          />
          <Typography 
            variant="h6" 
            sx={{ mt: 1, textAlign: "center" }}
          >
            {fullName}
          </Typography>
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ textAlign: "center" }}
          >
            {user?.email || ""}
          </Typography>
        </Box>
        
        <List sx={{ width: "100%" }}>
          <ListItem 
            button 
            onClick={() => handleMobileAction(() => navigate(`/profile/${_id}`))}
            sx={{ borderRadius: "8px", mb: 1 }}
          >
            <AccountCircleOutlined sx={{ mr: 2 }} />
            <ListItemText primary="My Profile" />
          </ListItem>
          
          <ListItem 
            button 
            onClick={() => handleMobileAction(() => navigate(`/vid-upload/${_id}`))}
            sx={{ borderRadius: "8px", mb: 1 }}
          >            <CloudUploadOutlined sx={{ mr: 2 }} />
            <ListItemText primary="Upload Video" />
          </ListItem>
          
          <ListItem 
            button 
            onClick={() => {
              handleMobileAction(() => {
                setShowNotifications(!showNotifications);
                if (!showNotifications) markNotificationsAsRead();
              });
            }}
            sx={{ borderRadius: "8px", mb: 1 }}
          >
            <NotificationsNone sx={{ mr: 2 }} />
            <ListItemText primary="Notifications" />
            {notificationCount > 0 && (
              <Box
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  width: "20px",
                  height: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  fontWeight: "bold"
                }}
              >
                {notificationCount}
              </Box>
            )}
          </ListItem>
          
          <Divider sx={{ my: 2 }} />
          
          <ListItem 
            button
            onClick={() => handleMobileAction(() => {
              dispatch(setLogout());
              navigate("/login");
            })}
            sx={{ 
              borderRadius: "8px", 
              mb: 1,
              color: "error.main",
              bgcolor: "error.light",
              "&:hover": { bgcolor: "error.light" }
            }}
          >
            <ExitToAppOutlined sx={{ mr: 2 }} />
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );

  return (
    <AppBar 
  position="fixed" 
  sx={{ 
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "white", // Changed from transparent to white
    boxShadow: "none", // Added subtle shadow
    width: { 
      xs: "100%", 
      sm: `calc(100% - 80px)` 
    },
    ml: { 
      xs: 0, 
      sm: "80px" 
    },
  }}
>
      <Toolbar 
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: { xs: 2, sm: 3, md: 4 },
          py: 1,
        }}
      >
        {/* Left - Logo (commented out to improve space usage) */}
        {/* 
        <Box 
          component="img"
          src={logo}
          alt="Company Logo"
          sx={{
            height: { xs: "40px", sm: "50px" },
            display: { xs: isExtraSmallScreen ? "none" : "block", sm: "block" }
          }}
        />
        */}

        {/* Center - Search bar for all screen sizes */}
        {renderSearchBar()}

        {/* Right - Action buttons */}
        <FlexBetween gap={isExtraSmallScreen ? "0.5rem" : "1rem"}>
          {/* Notification button - visible on all screen sizes */}
          {renderNotificationButton()}
          
          {/* Upload button - always visible but text conditionally shown */}
          {renderUploadButton()}

          {/* User avatar - show on all screens */}
          <IconButton onClick={toggleDropdown}>
            <UserImage 
              image={user?.picturePath} 
              size={isExtraSmallScreen ? "35px" : "40px"}
              border="1px solid #007bff"
            />
          </IconButton>

         {/* Hamburger menu for small screens */}
         {/* {isSmallScreen && (
            <IconButton 
              edge="end" 
              onClick={toggleMobileMenu}
              sx={{ ml: 0.5 }}
            >
              <Menu />
            </IconButton>
          )} */}
        </FlexBetween>
      </Toolbar>
      
      {/* Dropdown menus - shown conditionally */}
      {renderUserDropdown()}
      {renderMobileDrawer()}
    </AppBar>
  );
};

export default Navbar;
